import { render, staticRenderFns } from "./ArticleTransform.vue?vue&type=template&id=02fdfd1e"
import script from "./ArticleTransform.vue?vue&type=script&lang=js"
export * from "./ArticleTransform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports